<template>
    <div>
        <div v-if="showDropdown">
            <aha-nav-dropdown role="dialog" has-popup="dialog" position="right" extra-classes="c-top-nav__link c-cta dropdown-toggle" :disable-menu-events="true" @shown="onShown" @hidden="onHidden">
                <slot></slot>

                <template slot="dropdown">
                    <slot name="content"></slot>

                    <aha-location-selector-form :endpoint="searchEndpoint" :states="states" :translations="translations" :is-visible="isVisible" :on-submit="handleSubmit"></aha-location-selector-form>
                </template>
            </aha-nav-dropdown>
        </div>

        <div v-else>
            <slot name="content"></slot>
            <aha-location-selector-form :endpoint="searchEndpoint" :states="states" :translations="translations" :is-visible="isVisible" :on-submit="handleSubmit"></aha-location-selector-form>
        </div>
    
        <div v-if="showModal">
            <aha-modal ref="locationSelectorModal" id="locationSelectorModal" class="c-location-modal" hide-footer centered lazy>
                <template slot="modal-header">
                    <h2 class="c-location-modal__heading h4">{{ translations.searchResults }} <i>"{{ searchText }}"</i></h2>
                </template>

                <b-btn-close @click="$root.$emit('bv::hide::modal', 'locationSelectorModal', $event.target)">×</b-btn-close>

                <aha-location-selector-table :translations="translations" :locations="locations"></aha-location-selector-table>
            </aha-modal>
        </div>

        <div v-else class="c-location-selector__mobile-table">
            <div v-if="locations.length">
                <div class="c-location-selector__mobile-header">
                    <h2 class="c-location-modal__heading h4">{{ translations.searchResults }} <i>"{{ searchText }}"</i></h2>
                    <span class="c-cta h-theme--red" @click="clearResults">{{ translations.clearResults }}</span>
                </div>

                <aha-location-selector-table :translations="translations" :locations="locations"></aha-location-selector-table>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        data() {
            return {
                searchText: '',
                locations: [],
                isVisible: false
            };
        },
        props: {
            showDropdown: {
                type: Boolean,
                default: true
            },
            showModal: {
                type: Boolean,
                default: true
            },
            translations: {
                type: Object,
                required: true,
                default: {
                    "search": "Search", 
                    "or": "or", 
                    "searchResults": "Search results for", 
                    "clearResults": "Clear Results", 
                    "offices": "Offices", 
                    "address": "Address", 
                    "city": "City", 
                    "state": "State", 
                    "zipCode": "Zip Code" 
                }
            },
            searchEndpoint: {
                type: String,
                required: true
            },
            states: {
                type: Array,
                default: () => []
            }
        },
        methods: {
            clearResults() {
                this.locations = [];
                this.searchText = '';
            },
            handleSubmit(response) {
                this.searchText = response.searchText;
                this.locations = response.locations;

                this.$refs.locationSelectorModal.show();
            },
            hideModal() {
                this.$refs.locationSelectorModal.hide();
            },
            onShown() {
                this.isVisible = true;
            },
            onHidden() {
                this.isVisible = false;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/app/components/location-selector.vue